// EC-27 : Sub Task - 553 Cart Page 
// Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments.
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { addressInfoDisplayStyles } from "@WhiteCap/Overrides/Components/AddressInfoDisplay";
import { css } from "styled-components";

addressInfoDisplayStyles.address1Text = {
	css: css`
		font-size: 14px;
	`,
	as: "p" // EC-617 : Fixing css issues on PLP & PDP
}

addressInfoDisplayStyles.wrapper = {
	css: css`
		font-size: 14px !important;
		font-style: normal;
		${({ theme }: { theme: BaseTheme }) =>
			breakpointMediaQueries(theme, [
			css`
				p{
					font-size:14px;
				}
				`,
				css`
					p{
					font-size:14px;
				}
				`,
				css``,
				css``,
				css``,
		])}
	`
}
// End: Refactored dynamic CSS from CMS to code for consistent behavior across environments.